import styled from 'styled-components';

export const Panel = styled.div<{ panelHeight?: number }>`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 360px;
  max-width: calc(100vw - 32px);
  height: ${(props) => (props.panelHeight ? `${props.panelHeight}px` : 'auto')};
  overflow-y: auto;
  background: ${(props) => props.theme.$white};
  border-radius: 8px;
  box-shadow: 0 8px 24px ${(props) => props.theme.$black}26;
  padding: 20px;
  z-index: 1050;
  text-align: left;

  .filters-title {
    font-size: 18px;
  }

  .filters-label {
    font-size: 15px;
    color: ${(props) => props.theme.$gray900};
  }

  .filters-input-box,
  .filters-daterange {
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 4px;
  }

  .filters-daterange {
    padding: 0 8px;
  }

  input.form-control {
    border: 0;
    box-shadow: none;
    background: transparent;
  }

  .material-icons {
    font-size: 18px;
  }
`;
